import messageIntl from '../message/messageIntl';
import deliveryMessages from '../delivery/deliveryMessages';
import { preferencesAreLoaded } from '../brand/brandSelectors';
import { catalogsLoadedAndSoldOut } from '../catalogs/catalogSelectors';
import { getSoldOutPath } from '../routing/flow';
import { newItemIsAccessoriesStepForSelfBuy } from '../accessories/accessoriesUtils';

import amountMessages from './amountMessages';
import { amountStepPostConditions, amountStepPreConditions } from './amountStepSelectors';
import { getAccessoryPromoData } from '../accessories/accessoriesModule';



const amountStepConfig = {
    component: () => import('./AmountStep'),
    flow: 'buy',
    flowProps: (state, ownProps) => {
        const { isSelfBuy, isPlastic } = ownProps;
        const isAccessoriesStepForSelfBuy = newItemIsAccessoriesStepForSelfBuy(state);

        let submitText = amountMessages.button;
        if (isSelfBuy && !isAccessoriesStepForSelfBuy) {
            if (isPlastic) {
                submitText = messageIntl.button;
            } else {
                submitText = deliveryMessages.button;
            }
        }

        if (isSelfBuy && isAccessoriesStepForSelfBuy) {
            submitText = messageIntl.accessoryHeader;
        }

        return {
            submitText,
            isAccessoriesStepForSelfBuy
        };
    },
    isReady: state => (
        preferencesAreLoaded(state)
    ),
    canLoad: state => ({
        isAllowedOrPath: (!catalogsLoadedAndSoldOut(state) || getSoldOutPath())
    }),
    onExit: (dispatch, ownProps) => {
        const { isAccessoriesStepForSelfBuy } = ownProps;
        if (isAccessoriesStepForSelfBuy) {
            dispatch(getAccessoryPromoData());
        }
    },
    preConditions: amountStepPreConditions,
    postConditions: amountStepPostConditions
};

export default amountStepConfig;
